import FalconCloseButton from 'components/common/FalconCloseButton';
import moment from 'moment-timezone';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Button, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useFeedbackMutation } from 'utils/rest/feedback/postFeedback';

const questions = {
  q_1: 'How easy was it to find the information you were looking for on Sky Toolkit?',
  q_2: 'What was the primary reason for your visit to the Sky Toolkit, and were you able to accomplish it successfully?',
  q_3: 'If you encountered any difficulties using the Sky Toolkit, please describe them in detail.',
  q_4: 'How would you rate the overall design and appearance of Sky Toolkit? (rate on a scale of 1 to 5 where 1 is very poor and 5 is excellent)',
  q_5: 'Is there anything we could do to improve or add to the Sky Toolkit to enhance your experience in the future?'
};

const Feedback = ({ show, close }) => {
  const { user } = useSelector(state => state.auth);

  const britishTime = moment.tz('Europe/London').format('YYYY-MM-DD HH:mm:ss');

  const [formData, setFormData] = useState({
    name: `Toolkit Feedback ${user?._id} ${britishTime}`,
    q_1_answer: '',
    q_2_answer: '',
    q_3_answer: '',
    q_4_answer: '',
    q_5_answer: ''
  });

  const { mutate: feedback, isPending } = useFeedbackMutation();

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    console.log(formData);
    const body = {
      name: formData.name,
      msgISsmallplaintextbox: `${questions['q_1']} /n ${formData.q_1_answer} /n/n ${questions['q_2']} /n ${formData.q_2_answer} /n/n ${questions['q_3']} /n ${formData.q_3_answer} /n/n ${questions['q_4']} /n ${formData.q_4_answer} /n/n ${questions['q_5']} /n ${formData.q_5_answer} /n/n`
    };

    feedback(body, { onSuccess: close() });
  };

  return (
    <Modal
      show={show}
      onHide={close}
      contentClassName="border-0"
      centered
      size="lg"
    >
      <Modal.Header className="bg-modal-header light border-bottom-0">
        <FalconCloseButton noOutline onClick={close} />
      </Modal.Header>
      <Modal.Body>
        <fieldset className={'form-legend-wrapper pb-4'}>
          <legend className="item-title fs-1 fw-semi-bold">
            Toolkit Feedback
          </legend>
          <p className="mb-0 px-5 text-center">
            We are continuing to develop and improve the Sky toolkit and need
            your help to do so. Please take a few moments to feedback on your
            experience today
          </p>
          <Form onSubmit={handleSubmit} className="px-6 pt-4">
            <fieldset className={'form-legend-item-wrapper mb-4'}>
              <legend className="item-title fs-0 fw-semi-bold">
                How easy was it to find the information you were looking for on
                Sky Toolkit?
              </legend>
              <Form.Control
                placeholder="Type your answer here..."
                className="mb-1"
                value={formData.q_1}
                name="q_1_answer"
                onChange={handleChange}
              />
            </fieldset>
            <fieldset className={'form-legend-item-wrapper mb-4'}>
              <legend className="item-title fs-0 fw-semi-bold">
                What was the primary reason for your visit to the Sky Toolkit,
                and were you able to accomplish it successfully?
              </legend>
              <Form.Control
                placeholder="Type your answer here..."
                className="mb-1"
                value={formData.q_2}
                name="q_2_answer"
                onChange={handleChange}
              />
            </fieldset>
            <fieldset className={'form-legend-item-wrapper mb-4'}>
              <legend className="item-title fs-0 fw-semi-bold">
                If you encountered any difficulties using the Sky Toolkit,
                please describe them in detail.
              </legend>
              <Form.Control
                placeholder="Type your answer here..."
                className="mb-1"
                value={formData.q_3}
                name="q_3_answer"
                onChange={handleChange}
              />
            </fieldset>
            <fieldset className={'form-legend-item-wrapper mb-4'}>
              <legend className="item-title fs-0 fw-semi-bold">
                How would you rate the overall design and appearance of Sky
                Toolkit? (rate on a scale of 1 to 5 where 1 is very poor and 5
                is excellent)
              </legend>
              <Form.Control
                placeholder="Type your answer here..."
                className="mb-1"
                value={formData.q_4}
                name="q_4_answer"
                onChange={handleChange}
              />
            </fieldset>
            <fieldset className={'form-legend-item-wrapper mb-4'}>
              <legend className="item-title fs-0 fw-semi-bold">
                Is there anything we could do to improve or add to the Sky
                Toolkit to enhance your experience in the future?
              </legend>
              <Form.Control
                placeholder="Type your answer here..."
                className="mb-1"
                value={formData.q_5}
                name="q_5_answer"
                onChange={handleChange}
              />
            </fieldset>

            <Button variant="primary" type="submit" disabled={isPending}>
              Submit Feedback
            </Button>
          </Form>
        </fieldset>
      </Modal.Body>
    </Modal>
  );
};

export default Feedback;
